import { render, staticRenderFns } from "./ComplainsAdmin.vue?vue&type=template&id=1bf2c7e4&"
import script from "./ComplainsAdmin.vue?vue&type=script&lang=js&"
export * from "./ComplainsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports